'use client'

import { motion } from 'framer-motion'
import { Download, Link2, TrendingUp } from 'lucide-react'
import { Container } from '@/components/ui/container'
import { Section } from '@/components/ui/section'

const steps = [
  {
    icon: Download,
    number: '01',
    title: 'Install',
    description:
      'Add Buddify to your Shopify store in seconds. No coding required.',
  },
  {
    icon: Link2,
    number: '02',
    title: 'Connect',
    description:
      'Browse our marketplace and connect with brands that complement your store.',
  },
  {
    icon: TrendingUp,
    number: '03',
    title: 'Grow',
    description:
      'Start selling partner products and let AI convert more visitors into customers.',
  },
]

export function HowItWorks() {
  return (
    <Section background="gray" id="how-it-works">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-display-1 text-stone-900 mb-4">
            Get Started in Minutes
          </h2>
          <p className="text-body-lg max-w-2xl mx-auto">
            Three simple steps to transform your e-commerce business.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative text-center"
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-stone-200">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 rotate-45 border-r-2 border-t-2 border-stone-300" />
                </div>
              )}

              <div className="relative z-10 inline-flex flex-col items-center">
                <div className="w-24 h-24 bg-white rounded-2xl shadow-lg flex items-center justify-center mb-6">
                  <step.icon className="w-10 h-10 text-primary-600" />
                </div>
                <span className="text-xs font-bold text-primary-600 tracking-widest mb-2">
                  {step.number}
                </span>
                <h3 className="text-h4 text-stone-900 mb-2">{step.title}</h3>
                <p className="text-body max-w-xs">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
